import { useContext } from 'react';
import { DetailsChartsDataContext } from '../contexts/DetailsChartsDataContext';

export const useDetailsChartsDataContext = () => {
    return useContext(DetailsChartsDataContext);
};
